import { Capacitor } from '@capacitor/core';

// Issue #90: pinch/double-tap zoom and the <16px input focus auto-zoom could
// leave the iOS app stuck zoomed in. WKWebView (unlike mobile Safari) honors
// viewport scale limits, so locking scale on the native shell disables all of
// them. The web app keeps the permissive viewport for accessibility.
const LOCKED_VIEWPORT =
  'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, viewport-fit=cover';

export function lockNativeViewportZoom() {
  if (!Capacitor.isNativePlatform()) return;
  const meta = document.querySelector('meta[name="viewport"]');
  if (meta) meta.setAttribute('content', LOCKED_VIEWPORT);
}
